const BASE_ENDPOINT = '/iphone_spa/saml';

export const paths = {
  setting: `${BASE_ENDPOINT}/enterprises/:name/saml_setting`,
  authorizationToken: `${BASE_ENDPOINT}/authorization_token`,
  iphoneRegistrationToken: `${BASE_ENDPOINT}/iphone_registration_token`,
};
